var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.8125 11.6875H18.5625C18.7448 11.6875 18.9197 11.6151 19.0486 11.4861C19.1776 11.3572 19.25 11.1823 19.25 11C19.25 10.8177 19.1776 10.6428 19.0486 10.5139C18.9197 10.3849 18.7448 10.3125 18.5625 10.3125H4.8125C4.63016 10.3125 4.4553 10.3849 4.32636 10.5139C4.19743 10.6428 4.125 10.8177 4.125 11C4.125 11.1823 4.19743 11.3572 4.32636 11.4861C4.4553 11.6151 4.63016 11.6875 4.8125 11.6875Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.0964 11.0001L10.7985 5.29936C10.9276 5.17026 11.0001 4.99518 11.0001 4.81261C11.0001 4.63004 10.9276 4.45495 10.7985 4.32586C10.6694 4.19676 10.4943 4.12424 10.3118 4.12424C10.1292 4.12424 9.95412 4.19676 9.82503 4.32586L3.63753 10.5134C3.5735 10.5772 3.52271 10.6531 3.48805 10.7366C3.45339 10.8201 3.43555 10.9097 3.43555 11.0001C3.43555 11.0905 3.45339 11.1801 3.48805 11.2636C3.52271 11.3471 3.5735 11.423 3.63753 11.4869L9.82503 17.6744C9.95412 17.8035 10.1292 17.876 10.3118 17.876C10.4943 17.876 10.6694 17.8035 10.7985 17.6744C10.9276 17.5453 11.0001 17.3702 11.0001 17.1876C11.0001 17.005 10.9276 16.83 10.7985 16.7009L5.0964 11.0001Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.66122a8ba6777fe6d62631207169b0ce.svg";
export { ForwardRef as ReactComponent };